
























































































import 'reflect-metadata'
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import * as MSAL from '@azure/msal-browser'
import { config } from '@/config'
import { AuthenticateApi, GraphMicrosoftApi, HomeApi, PlanningTransferApi } from "@/api"
import { ConditionDisabledInspectionAppointmentStatusLatest } from '@/resource/planning-cr/DataTableValidate'
const AppInfo = namespace('app')

const Auth = namespace('authentication')

@Component
export default class Login extends Vue { 
    loading = false
    errorLogin = false
    appVersion = config.version
    apiVersion = 0
    isLoginViewData = false
    isHideBtnLoginViewData = false

    redirectUrlNext = ""
    menuLists: any[] = []
    masterMenuLists: any[] = [
        { path: '/planning/transfercr', profileCode: 'TFP-01' },
        { path: '/planning/transfercr', profileCode: 'TFP-02' },
        { path: '/planning/transferpj', profileCode: 'TFP-03' },
        { path: '/planning/transferpj', profileCode: 'TFP-04' },
        { path: '/report/trackingtransfer', profileCode: 'TFP-05' },
        { path: '/report/inspectionPlan', profileCode: 'TFP-06' },
        { path: '/report/hierarchy', profileCode: 'TFP-07' },
        { path: '/report/bankcredit', profileCode: 'TFP-08' }
    ]
    isBtnLogin = false
    isBtnLoginViewData = false
    isBtnLogOutViewData = false
    isAlertViewData = false
    
    @Auth.Action
    private AUTHINFO!: (auth: any) => Promise<any>

    @AppInfo.Action
    private MENU_LISTS!: (route: string) => Promise<any>
    
    async created () {
        if (this.isUrlViewData()) {
            this.isBtnLoginViewData = true
            this.isBtnLogin = false
        } else {
            this.isBtnLoginViewData = false
            this.isBtnLogin = true
            this.isAlertViewData = false
        }
        const redirectUrl = this.$route.query.redirect ?? ``
        localStorage.setItem('redirectUrlTemp', `${redirectUrl}`)

        // const accounts: MSAL.AccountInfo[] = AuthenticateApi.msalInstance.getAllAccounts()
        // if (accounts.length > 0) {
        //     this.isBtnLoginViewData = false
        //     this.isBtnLogOutViewData = true
        // } else {
        //     this.isBtnLogOutViewData = false
        // }

        if (!this.isBtnViewData()) {
            this.isBtnLoginViewData = false
            this.isBtnLogOutViewData = false
            this.isUrlViewData() === true ? this.isAlertViewData = true : this.isAlertViewData = false
        } else {
            this.isAlertViewData = false
        }
    }

    compareMasterListsWithPermissions(masterLists: any[], permissions: any[]) {
        return masterLists.map(master => {
            const matchedPermission = permissions.find(permission => permission.profileCode === master.profileCode);
            return {
                ...master,
                permission: matchedPermission ? matchedPermission.permission : null // Add permission if found, otherwise null
            };
        });
    }
    
    async mounted () {
        const version = await HomeApi.Version()
        this.apiVersion = version
    }

    async btnLogin () {
        this.loading = true
        localStorage.clear()
        await AuthenticateApi.LoginAD()

        try {
            const getUserInfo = await AuthenticateApi.GetUserInfo()
            const accounts: MSAL.AccountInfo[] = AuthenticateApi.msalInstance.getAllAccounts()
            if (accounts.length > 0 && getUserInfo && getUserInfo.permission.length > 0) {
                if (accounts[0].name) {
                    const imagePath = await GraphMicrosoftApi.GetImageProfile()
                    this.AUTHINFO({ 
                        username: accounts[0].name,
                        imageProfile: imagePath,
                        email: getUserInfo!.email,
                        userFlag: getUserInfo!.userFlag,
                        userRoleId: getUserInfo!.userRoleId,
                        userDeptId: getUserInfo!.userDeptId,
                        userDeptCode: getUserInfo!.userDeptCode,
                        permission: getUserInfo!.permission
                    })
                }

                const logModel = {
                    application_name: "Transfer_Planning",
                    feature: "Login Success",
                    page: "Login",
                    json_data: JSON.stringify(getUserInfo),
                    created_by: accounts[0].name,
                };
                PlanningTransferApi.addLog(logModel)     

                localStorage.setItem('isAuth', 'authorized')
                localStorage.setItem('isUser', 'userTracking')

            } 
            else 
            {
                const logModel = {
                    application_name: "Transfer_Planning",
                    feature: "Login Fail",
                    page: "Login",
                    json_data: JSON.stringify(getUserInfo),
                    created_by: "",
                };
                PlanningTransferApi.addLog(logModel)

                localStorage.setItem('isAuth', 'unauthorized')
                localStorage.setItem('isUser', '') 
                this.errorLogin = true
            } 

            const result = this.masterMenuLists.find(menu => getUserInfo!.permission.some(permission => permission.profileCode === menu.profileCode) )
            this.redirectUrlNext = result.path
            localStorage.setItem("setDefaultPage",this.redirectUrlNext)

            await this.MENU_LISTS(this.redirectUrlNext)

            this.loading = false
            let redirectUrl = this.$route.query.redirect ?? this.redirectUrlNext
            this.$router.push(`${redirectUrl}`)

        } 
        catch 
        { 
            localStorage.setItem('isAuth', 'unauthorized')
            this.errorLogin = true
            this.loading = false
        }
    }

    async btnLoginViewData () {
        this.loading = true
        //localStorage.clear()
        await AuthenticateApi.LoginAD()
        let redirectPath = this.$route.query.redirect ?? ''

        if (redirectPath === undefined || redirectPath === '/login' || redirectPath === '' || redirectPath === '/') 
        {
            redirectPath = localStorage.getItem('viewPathData') ?? ''
        } 

        try { 
            const accounts: MSAL.AccountInfo[] = AuthenticateApi.msalInstance.getAllAccounts()

            if (accounts.length > 0 ) {
                if (accounts[0].name) {
                        const imagePath = await GraphMicrosoftApi.GetImageProfile()
                        this.AUTHINFO({ 
                            username: accounts[0].name,
                            imageProfile: imagePath,
                            email: accounts[0].username,
                            userFlag: '',
                            userRoleId: '',
                            userDeptId: '',
                            userDeptCode: '',
                            permission: []
                        })

                        const logModel = {
                            application_name: "Transfer_Planning",
                            feature: "Login Success",
                            page: "Login View Data",
                            json_data: JSON.stringify(accounts),
                            created_by: accounts[0].name,
                        };
                        PlanningTransferApi.addLog(logModel)

                    localStorage.setItem('isAuth', 'authorized')
                    localStorage.setItem('isUser', 'UserTracking')
                    this.loading = false

                    console.log("After login Success: ", redirectPath)
                    this.$router.push(`${redirectPath}`)
                } 
            }
            else 
            {
                console.log('User Not Authorized')

                localStorage.setItem('isAuth', 'unauthorized')
                this.errorLogin = true
                localStorage.setItem('isUser', '')
                this.loading = false
                console.log("After login Not Success: ", localStorage.getItem("pathViewData"))
                this.$router.push(`${redirectPath}`)
            }

        } 
        catch 
        { 

            console.log('No isCheckUserDB Not error')
            localStorage.setItem('isAuth', 'unauthorized')
            this.errorLogin = true
            this.loading = false
        }
    }

    async btnLogOutViewData () {
		await AuthenticateApi.LogOutAd()
		localStorage.clear()
		window.location.reload()
	}

    async isCheckUserDB () {
        try {
            return await AuthenticateApi.GetUserInfo()
        } catch {
            return false
        }
    }

    isUrlViewData () {    
        const redirectUrl = this.$route.query.redirect ?? ''
        const isViewData = redirectUrl.includes('viewdata')
        return isViewData
    }

    isBtnViewData () {
        const isViewDataUrlList = [
            '/viewdata/emailtransfer',
            '/viewdata/emailalertsummarytransfer',
            '/viewdata/unittransfered',
            '/viewdata/emailtransfersummary',
            '/viewdata/emailalertdaily',
            '/viewdata/emailalertseveninspection'
	    ]

        const redirect: string = this.$route.query.redirect as string ?? ''
        const isRedirect = redirect.split('?') ?? []

        console.log('isViewDataUrlList', isViewDataUrlList)
        console.log('redirect', redirect)
        console.log('isRedirect', isRedirect)

        return isViewDataUrlList.includes(isRedirect[0])
    }
}
